import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-data-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './data-container.component.html',
  styleUrls: ['./data-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataContainerComponent {
  /**
   * Header title for the card
   */
  title = input<string>('');

  /**
   * Optional icon to display in the header
   */
  icon = input<string>('');
}
